export default "__VITE_ASSET__B3Nr$oQW__"